// extracted by mini-css-extract-plugin
module.exports = {"button":"Password_button__3vEFI","buttons":"Password_buttons__3CYGF"};